import { demoWorkspace, type Workspace } from "./workspace";

/** Explicitly selected training data, never a substitute for a missing recording. */
export function exampleWorkspace(): Workspace {
  const workspace = demoWorkspace();
  return {
    ...workspace,
    source: { ...workspace.source, name: "Example roast (synthetic)" },
    events: [
      { id: "example-turn", name: "Turning point", elapsedMs: 75000, note: "Synthetic example: bean temperature starts rising." },
      { id: "example-color", name: "Color change", elapsedMs: 240000, note: "Synthetic example: beans have turned yellow." },
      { id: "example-heat", name: "Heat adjustment", elapsedMs: 360000, note: "Synthetic example: reduced heat input." },
      { id: "example-crack", name: "First crack", elapsedMs: 480000, note: "Synthetic example: first audible cracks." },
      { id: "example-drop", name: "Drop", elapsedMs: 600000, note: "Synthetic example: roast ended." },
    ],
  };
}
